import { render } from "./AdditionalsContainer.vue?vue&type=template&id=0b5430ce"
import script from "./AdditionalsContainer.vue?vue&type=script&lang=js"
export * from "./AdditionalsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__